import { createSlice } from '@reduxjs/toolkit';
import { readStoredAuth } from '../utils/authStorage';

// slice ( action + reducer )
export const infoSlice = createSlice({
    name: 'info',
    initialState: {
        geolocation: {
            lat: null,
            lon: null,
        },
        auth: readStoredAuth(),
        nightMode: {
            isInProgress: false,
            updatedDate: null,
            startTime: null,
        },
    },
    reducers: {
        setGeolocation(state, action) {
            state.geolocation.lat = action.payload.lat;
            state.geolocation.lon = action.payload.lon;
        },
        setAuth(state, action) {
            state.auth.isLoggedIn = action.payload.accessToken ? true : false;
            state.auth.accessToken = action.payload.accessToken;
            state.auth.refreshToken = action.payload.refreshToken;
        },
        setNightMode(state, action) {
            state.nightMode.isInProgress = action.payload.isInProgress;
            state.nightMode.updatedDate = new Date().getTime();
            state.nightMode.startTime = action.payload.startTime;
        },
    },
});

// export actions
export const { setGeolocation, setAuth, setNightMode } = infoSlice.actions;

// export selector
export const selectGeolocation = state => state.info.geolocation;
export const selectAuth = state => state.info.auth;
export const selectNightMode = state => state.info.nightMode;

// export reducer
export default infoSlice.reducer;
